module.exports = __webpack_public_path__ + "sunsemweb/img/sqq.28dcbb00.png";